import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import {
  InstallationMixing
} from '../../../../models/configurators-2d/applications/fence/installations/installation-mixing';
import { FenceService } from '../../../../services/configurators-2d/applications/fence.service';
import { from, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstallationMixingStateService {
  /**
   * Liste des mixages de pose
   */
  installationMixings: WritableSignal<InstallationMixing[]> = signal([]);

  /**
   * Indique si le service est entrain de faire des changements
   */
  loading: WritableSignal<boolean> = signal(false);

  private readonly fenceService = inject(FenceService);

  setList(): Observable<InstallationMixing[]> {
    this.loading.set(true);

    return from(this.fenceService.getInstallationMixings()).pipe(
      tap((res: InstallationMixing[]) => {
        this.installationMixings.set(res);
        this.loading.set(false);
      })
    );
  }

  get(installationId1: number, installationId2: number): InstallationMixing {
    return this.installationMixings().find(
      im => (im.primaryInstallation.id === installationId1 && im.secondaryInstallation.id === installationId2)
        || (im.primaryInstallation.id === installationId2 && im.secondaryInstallation.id === installationId1)
    );
  }
}
